import React from 'react';
import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './_breadcrumbs.scss';
import { BreadCrumbNodeT } from '../../types';

type BreadcrumbsProps = {
    breadcrumbs: BreadCrumbNodeT[];
    onClick: FlowAnyFunction;
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = (props: BreadcrumbsProps) => {
    const { breadcrumbs } = props;

    return (
        (breadcrumbs.length > 1 && (
            <div className="breadcrumbs">
                {breadcrumbs.map((breadcrumb, i) => {
                    const isLast = i === breadcrumbs.length - 1;
                    return (
                        <div key={breadcrumb.value} className="breadcrumb">
                            <Button
                                size="small"
                                onClick={() => props.onClick(breadcrumb)}
                            >
                                {breadcrumb.label}
                            </Button>
                            {!isLast && <ChevronRightIcon />}
                        </div>
                    );
                })}
            </div>
        )) ||
        null
    );
};
export default Breadcrumbs;
